// extracted by mini-css-extract-plugin
export default {"card":"DocumentCard_card__Hd79s","divider":"DocumentCard_divider__3Bvqb","footer":"DocumentCard_footer__N51Ss","anchor":"DocumentCard_anchor__crWta"};